import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import cn from 'classnames';

import { INSTITUTION_IMAGES } from 'Constants';

import { Button, Display } from 'Views/Components/Button/Button';
import NavbarUserDropdown from 'Views/Components/Navbar/NavbarUserDropdown';
import { Conditional } from 'Views/Components/Conditional/Conditional';
import { capitalize, toLower } from 'lodash';

interface NavbarProps {
	hideNavButtons?: boolean;
}

const Navbar = (props: NavbarProps) => {
	const { hideNavButtons } = props;

	const history = useHistory();
	const location = useLocation();

	const isPlanRoute = location.pathname.startsWith('/plans');
	const isUsersRoute = location.pathname.startsWith('/users');

	return (
		<nav className="navbar" aria-label="navbar">
			<div className="institute-logo">
				<img
					src={INSTITUTION_IMAGES.LOGO}
					className="institute-logo"
					alt="institute-logo"
				/>
			</div>
			<Conditional
				condition={!hideNavButtons}
				component={() => (
					<div className="nav-buttons">
						<Button
							className={cn('plans', { active: isPlanRoute })}
							display={Display.Text}
							icon={{ icon: 'playlist-add-check', iconPos: 'icon-left' }}
							onClick={() => history.replace('/plans')}
						>
							My {toLower(window.lexicon.studyPlans)}
						</Button>
						<Button
							className={cn('users', { active: isUsersRoute })}
							display={Display.Text}
							icon={{ icon: 'group', iconPos: 'icon-left' }}
							onClick={() => history.replace('/users')}
						>
							Users
						</Button>
					</div>
				)}
				componentProps={{}}
			/>

			<NavbarUserDropdown />
		</nav>
	);
};

export default Navbar;
